export type AuthStatus = "ok" | "expired" | "offline";

let sessionExpiredHandled = false;
let isLoggedInFn: (() => boolean) | null = null;
let onExpiredFn: (() => void) | null = null;

export function configureSessionExpiry(opts: {
  isLoggedIn: () => boolean;
  onExpired: () => void;
}) {
  isLoggedInFn = opts.isLoggedIn;
  onExpiredFn = opts.onExpired;
}

export function resetSessionExpired() {
  sessionExpiredHandled = false;
}

export async function checkAuthStatus(): Promise<AuthStatus> {
  try {
    let rsp = await fetch("/auth/user");
    if (rsp.status === 401) {
      return "expired";
    }
    if (rsp.status === 200) {
      return "ok";
    }
    return "offline";
  } catch {
    return "offline";
  }
}

export function handleSessionExpired() {
  if (sessionExpiredHandled || !isLoggedInFn?.()) {
    return;
  }
  sessionExpiredHandled = true;
  onExpiredFn?.();
}
